import * as ACTION_TYPES from "../actions/action_types";

export const initialState = {
  site: "NoSite",
  iframeUrl: "",
  paymentStatusFrom: "",
};

export const SiteReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.SET_SITE:
      return {
        ...state,
        site: action.payload,
      };
    case ACTION_TYPES.PAYMENT_STATUS_FORM:
      return {
        ...state,
        paymentStatusFrom: action.payload,
      };
    case ACTION_TYPES.IFRAME_URL:
      return {
        ...state,
        iframeUrl: action.payload,
      };
    case ACTION_TYPES.FAILURE:
      return {
        ...state,
        site: "FAILURE",
      };
    default:
      return state;
  }
};
